import { defineMessages } from '@faceup/localization'
import { CaseStatusGroup } from '@faceup/utils'

export const sharedMessages = defineMessages('followUp.shared', [
  { id: 'apiError', defaultMessage: 'An error occurred. Please try again.' },
  { id: 'attachmentsTooManyFiles', defaultMessage: 'You can upload a maximum of 20 attachments.' },
  {
    id: 'attachmentsTooLargeFile',
    defaultMessage: 'The file you are trying to upload is too large. Maximum file size is 50 MB.',
  },
  { id: 'metadataRemoved', defaultMessage: 'Metadata has been removed' },
  { id: 'metadataUnableToRemove', defaultMessage: 'Metadata has not been removed' },
  {
    id: 'unsupportedMimetype',
    defaultMessage:
      'We do not support this file type. Please, upload a file in JPG, PNG, PDF, DOC, DOCX, ODT, ODS, XLS, XLSX, TXT, MOV, MP3, MP4, AVI or WAV.',
  },
  { id: 'submit', defaultMessage: 'Send' },
  { id: 'save', defaultMessage: 'Save' },
  { id: 'savedMessage', defaultMessage: 'Saved' },
  { id: 'add', defaultMessage: 'Add' },
  { id: 'invalidInputError', defaultMessage: 'This field is required' },
  { id: 'continue', defaultMessage: 'Continue' },
  { id: 'fieldRequired', defaultMessage: 'This field is required' },
  { id: 'selectPlaceholder', defaultMessage: 'Select one' },
  { id: 'encryptionError', defaultMessage: 'Encryption error' },
  { id: 'globalNameLabel', defaultMessage: 'Your name and contact details' },
  { id: 'send', defaultMessage: 'Send' },
  { id: 'delete', defaultMessage: 'Delete' },
  { id: 'download', defaultMessage: 'Download' },
  { id: 'ok', defaultMessage: 'OK' },
  { id: 'cancel', defaultMessage: 'Cancel' },
  { id: 'bio', defaultMessage: '{name}', values: { name: true } },
  { id: 'partnerBio', defaultMessage: '{name}', values: { name: true } },
] as const)

export const reportStatusMessages = defineMessages('followUp.reportStatus', CaseStatusGroup, {
  [CaseStatusGroup.New]: 'New',
  [CaseStatusGroup.Open]: 'Open',
  [CaseStatusGroup.Closed]: 'Closed',
})
